import React from 'react';
import classnames from 'classnames';
import s from './RowWrapper.scss';

type Props = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

const RowWrapper = React.forwardRef<HTMLDivElement, Props>(({ className, ...props }, innerRef) => {
  return (
    <div
      data-testid="content_row"
      ref={innerRef}
      className={classnames(s['strip'], className)}
      {...props}
    />
  );
});
RowWrapper.displayName = 'RowWrapper';

export default RowWrapper;
